// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Types$OrcaPaymentPage from "./hyper-loader/Types.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as Payment$OrcaPaymentPage from "./Payment.bs.js";
import * as CardTheme$OrcaPaymentPage from "./CardTheme.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as Redsys3ds$OrcaPaymentPage from "./Redsys3ds.bs.js";
import * as PazeWallet$OrcaPaymentPage from "./Payments/PazeWallet.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as ThreeDSAuth$OrcaPaymentPage from "./ThreeDSAuth.bs.js";
import * as DefaultTheme$OrcaPaymentPage from "./DefaultTheme.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentLoader$OrcaPaymentPage from "./Components/PaymentLoader.bs.js";
import * as QRCodeDisplay$OrcaPaymentPage from "./Payments/QRCodeDisplay.bs.js";
import * as ThreeDSMethod$OrcaPaymentPage from "./ThreeDSMethod.bs.js";
import * as PlaidSDKIframe$OrcaPaymentPage from "./Payments/PlaidSDKIframe.bs.js";
import * as PreMountLoader$OrcaPaymentPage from "./Payments/PreMountLoader.bs.js";
import * as VoucherDisplay$OrcaPaymentPage from "./Payments/VoucherDisplay.bs.js";
import * as LoaderController$OrcaPaymentPage from "./LoaderController.bs.js";
import * as BankTransfersPopup$OrcaPaymentPage from "./Payments/BankTransfersPopup.bs.js";
import * as NetworkInformation$OrcaPaymentPage from "./Hooks/NetworkInformation.bs.js";
import * as ClickToPayLearnMore$OrcaPaymentPage from "./Components/ClickToPayLearnMore.bs.js";
import * as FullScreenDivDriver$OrcaPaymentPage from "./Components/FullScreenDivDriver.bs.js";
import * as NativeCryptoDisplay$OrcaPaymentPage from "./Payments/NativeCryptoDisplay.bs.js";
import * as ThreeDSRedirectionModal$OrcaPaymentPage from "./Payments/ThreeDSRedirectionModal.bs.js";
import * as CryptoCheckoutEnvironment$OrcaPaymentPage from "./Utilities/CryptoCheckoutEnvironment.bs.js";
import * as PaymentMethodCollectElement$OrcaPaymentPage from "./PaymentMethodCollectElement.bs.js";

function App(props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match = React.useState(function () {
        return false;
      });
  var setIntegrateErrorError = match[1];
  var integrateError = match[0];
  var setLoggerState = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var paymentMode = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var paymentType = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
  var networkStatus = NetworkInformation$OrcaPaymentPage.useNetworkInformation();
  var match$1 = React.useMemo((function () {
          return [
                  HyperLogger$OrcaPaymentPage.make(undefined, {
                        TAG: "Elements",
                        _0: paymentType
                      }, undefined, undefined, undefined),
                  Date.now()
                ];
        }), []);
  var initTimestamp = match$1[1];
  var logger = match$1[0];
  React.useEffect((function () {
          if (typeof networkStatus === "object") {
            logger.setLogInfo(JSON.stringify(networkStatus._0), "NETWORK_STATE", undefined, undefined, "DEBUG", undefined, undefined);
          }
          
        }), [networkStatus]);
  var fullscreenMode = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "fullscreenType");
  var handoffPaymentId = CryptoCheckoutEnvironment$OrcaPaymentPage.routePaymentId();
  React.useEffect((function () {
          setLoggerState(function (param) {
                return logger;
              });
        }), [logger]);
  React.useEffect((function () {
          var handleMetaDataPostMessage = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (Core__Option.isSome(dict["metadata"])) {
              var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
              var config = Utils$OrcaPaymentPage.getDictFromJson(metadata)["config"];
              if (config !== undefined) {
                var config$1 = CardTheme$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(config), DefaultTheme$OrcaPaymentPage.default, DefaultTheme$OrcaPaymentPage.defaultRules, logger);
                CardUtils$OrcaPaymentPage.generateFontsLink(config$1.fonts);
                var dict$1 = Utils$OrcaPaymentPage.getDictFromJson(config$1.appearance.rules);
                if (Object.entries(dict$1).length > 0) {
                  Utils$OrcaPaymentPage.generateStyleSheet("", dict$1, "mystyle");
                }
                
              }
              
            }
            var appearanceJson = Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentElementCreate") ? Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions")["appearance"] : (
                Utils$OrcaPaymentPage.getDictIsSome(dict, "fullScreenIframeMounted") ? dict["appearance"] : (
                    Utils$OrcaPaymentPage.getDictIsSome(dict, "ElementsUpdate") ? Utils$OrcaPaymentPage.getDictFromObj(dict, "options")["appearance"] : undefined
                  )
              );
            if (appearanceJson === undefined) {
              return ;
            }
            var colorScheme = CardTheme$OrcaPaymentPage.getColorScheme(Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(appearanceJson), "colorScheme", "light"));
            CardTheme$OrcaPaymentPage.setColorSchemeMeta(colorScheme);
          };
          window.addEventListener("message", handleMetaDataPostMessage);
          return (function () {
                    window.removeEventListener("message", handleMetaDataPostMessage);
                  });
        }), []);
  if (handoffPaymentId !== "") {
    return React.createElement(NativeCryptoDisplay$OrcaPaymentPage.make, {});
  }
  if (paymentMode === "paymentMethodCollect") {
    return React.createElement(LoaderController$OrcaPaymentPage.make, {
                children: React.createElement(PaymentMethodCollectElement$OrcaPaymentPage.make, {
                      integrateError: integrateError,
                      logger: logger
                    }),
                paymentMode: paymentMode,
                setIntegrateErrorError: setIntegrateErrorError,
                logger: logger,
                initTimestamp: initTimestamp
              });
  }
  switch (fullscreenMode) {
    case "3ds" :
        return React.createElement(ThreeDSMethod$OrcaPaymentPage.make, {});
    case "3dsAuth" :
        return React.createElement(ThreeDSAuth$OrcaPaymentPage.make, {});
    case "3dsRedirectionPopup" :
        return React.createElement(ThreeDSRedirectionModal$OrcaPaymentPage.make, {});
    case "clickToPayLearnMore" :
        return React.createElement(ClickToPayLearnMore$OrcaPaymentPage.make, {});
    case "fullscreen" :
        return React.createElement("div", {
                    id: "fullscreen"
                  }, React.createElement(FullScreenDivDriver$OrcaPaymentPage.make, {}));
    case "nativeCryptoData" :
        return React.createElement(NativeCryptoDisplay$OrcaPaymentPage.make, {});
    case "paymentloader" :
        return React.createElement(PaymentLoader$OrcaPaymentPage.make, {});
    case "pazeWallet" :
        return React.createElement(PazeWallet$OrcaPaymentPage.make, {
                    logger: logger
                  });
    case "plaidSDK" :
        return React.createElement(PlaidSDKIframe$OrcaPaymentPage.make, {});
    case "preMountLoader" :
        var sdkAuthorization = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "sdkAuthorization");
        var clientSecret = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "clientSecret");
        var sessionId = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "sessionId");
        var publishableKey = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "publishableKey");
        var endpoint = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "endpoint");
        var pmSessionId = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "pmSessionId");
        var hyperComponentName = Types$OrcaPaymentPage.getHyperComponentNameFromStr(CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "hyperComponentName"));
        var merchantHostname = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "merchantHostname");
        var customPodUri = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "customPodUri");
        var isTestMode = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "isTestMode") === "true";
        var isSdkParamsEnabled = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "isSdkParamsEnabled") === "true";
        var paymentId = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "paymentId");
        var profileId = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "profileId");
        return React.createElement(PreMountLoader$OrcaPaymentPage.make, {
                    sessionId: sessionId,
                    publishableKey: publishableKey,
                    sdkAuthorization: sdkAuthorization,
                    clientSecret: clientSecret,
                    endpoint: endpoint,
                    pmSessionId: pmSessionId,
                    hyperComponentName: hyperComponentName,
                    merchantHostname: merchantHostname,
                    customPodUri: customPodUri,
                    isTestMode: isTestMode,
                    isSdkParamsEnabled: isSdkParamsEnabled,
                    paymentId: paymentId,
                    profileId: profileId
                  });
    case "qrData" :
        return React.createElement(QRCodeDisplay$OrcaPaymentPage.make, {});
    case "redsys3ds" :
        return React.createElement(Redsys3ds$OrcaPaymentPage.make, {});
    case "achBankTransfer" :
    case "bacsBankTransfer" :
    case "sepaBankTransfer" :
        return React.createElement(BankTransfersPopup$OrcaPaymentPage.make, {
                    transferType: fullscreenMode
                  });
    case "voucherData" :
        return React.createElement(VoucherDisplay$OrcaPaymentPage.make, {});
    default:
      return React.createElement(LoaderController$OrcaPaymentPage.make, {
                  children: React.createElement(Payment$OrcaPaymentPage.make, {
                        paymentMode: paymentMode,
                        integrateError: integrateError,
                        logger: logger
                      }),
                  paymentMode: paymentMode,
                  setIntegrateErrorError: setIntegrateErrorError,
                  logger: logger,
                  initTimestamp: initTimestamp
                });
  }
}

var make = App;

export {
  make ,
}
/* react Not a pure module */
